import { render, staticRenderFns } from "./Autosuggest.vue?vue&type=template&id=49421668&scoped=true&"
import script from "./Autosuggest.vue?vue&type=script&lang=js&"
export * from "./Autosuggest.vue?vue&type=script&lang=js&"
import style0 from "./Autosuggest.vue?vue&type=style&index=0&id=49421668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49421668",
  null
  
)

export default component.exports